export default "/assets/laying-12-bronzing.b1fbe753cba7a265097108cde773d04c.jpeg";